const firebaseConfig = {
  apiKey: "AIzaSyCY531IIXZSrgLUw_uoiKsO8g0rYomI8vQ",
  authDomain: "codesandbox-practice-project.firebaseapp.com",
  databaseURL: "https://codesandbox-practice-project-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "codesandbox-practice-project",
  storageBucket: "codesandbox-practice-project.appspot.com",
  messagingSenderId: "108106237794",
  appId: "1:108106237794:web:516d97bf5bbf61b909ce3b"
};
export default firebaseConfig;